import jump from 'jump.js'

export default tee => {
  const jumpLink = document.querySelector('.js-explore-tee')

  jumpLink.addEventListener('click', () => {
    jump('.tee-slider', {
      offset: -100
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/the-every-edit-jump.js